import React from 'react';

export const getBackgroundLeft = () => (
  <svg width={670} height={962} viewBox="0 0 670 962" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g style={{ mixBlendMode: 'overlay' }} opacity={0.6}>
      <g opacity={0.3} clipPath="url(#clip0_201_21404)">
        <path d="M670 157.114L78 1068.89L349.653 157.114H670Z" fill="#1561D4" />
        <path d="M349.653 157.114L78.0005 1068.89L-193.652 157.114H349.653Z" fill="#5F9BF7" />
        <path d="M78 1068.78L-514 157H-193.653L78 1068.78Z" fill="#4E91F5" />
        <path d="M670 157.115H349.652L467.816 -239.508L670 157.115Z" fill="#3D87F8" />
        <path d="M467.817 -239.508L349.653 157.115L78 -239.508H467.817Z" fill="#7AAFFF" />
        <path d="M349.653 157.115H-193.652L78.0005 -239.508L349.653 157.115Z" fill="#B1D0FF" />
        <path d="M78.0001 -239.508L-193.653 157.115L-311.832 -239.508H78.0001Z" fill="#D7E7FF" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_201_21404">
        <rect width={1184} height={962} fill="white" transform="translate(-514)" />
      </clipPath>
    </defs>
  </svg>
);

export const getBackgroundRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={453} height={698} viewBox="0 0 453 698" fill="none">
    <g style={{ mixBlendMode: 'multiply' }}>
      <g opacity={0.3} clipPath="url(#clip0_201_21394)">
        <path d="M689.672 203.045L472.743 692.805L255.813 203.045H689.672Z" fill="#0065FF" />
        <path d="M472.743 692.805L0 203.045H255.814L472.743 692.805Z" fill="#4E91F5" />
        <path d="M689.672 203.045H255.813L472.743 -10L689.672 203.045Z" fill="#589AFF" />
        <path d="M472.743 -10L255.814 203.045L161.441 -10H472.743Z" fill="#86B6FF" />
        <path d="M255.814 203.045H0L161.442 -10L255.814 203.045Z" fill="#CCE0FF" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_201_21394">
        <rect width={945.487} height={708} fill="white" transform="translate(0 -10)" />
      </clipPath>
    </defs>
  </svg>
);

export const getBackgroundMobile = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={390} height={786} viewBox="0 0 390 786" fill="none">
    <g style={{ mixBlendMode: 'overlay' }} opacity={0.4}>
      <path d="M552 185L391.5 611L231 185H552Z" fill="#6DA6FC" />
      <path d="M392 611L41 185H230.936L392 611Z" fill="#4E91F5" />
      <path d="M551 185H230L390.5 -1L551 185Z" fill="#B1D0FF" />
      <path d="M391 -1L230.726 185L161 -1H391Z" fill="#D7E7FF" />
      <path d="M231 185H41L160.907 -1L231 185Z" fill="#F0F6FF" />
    </g>
  </svg>
);
